import { PollTabSectionStack } from "../PollTab.styles";
import { PollSectionTitleTypography } from "../../PostForm.styles";
import React from "react";
import { ImagesOptions } from "./ImagesOptions";

export function ImagesOptionsSection({
    allowPollEdit,
}: {
    allowPollEdit: boolean;
}) {
    return (
        <PollTabSectionStack>
            <PollSectionTitleTypography>
                {!allowPollEdit ? (
                    <>Wähle die Reihenfolge per Drag&Drop</>
                ) : (
                    <>Lade Bilder hoch (min. 2 / max. 4)</>
                )}
            </PollSectionTitleTypography>
            <ImagesOptions allowPollEdit={allowPollEdit} />
        </PollTabSectionStack>
    );
}
